module.exports = __webpack_public_path__ + "img/notice-modal-en-US.579c33a7.png";